import { ToggleButton, ToggleButtonGroup, clubbiStyled } from 'clubbi-ui'

export const StyledSelectionContainer = clubbiStyled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  gap: '8px',
  padding: '0 16px',
  paddingTop: '24px',
  position: 'relative',
}))

export const StyledTitle = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontWeight: 500,
  fontSize: '12px',
  justifyContent: 'space-between',
  width: '100% !important',
  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.fontSizeXXS,
  },
}))

export const StyledTag = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
}))

export const StyledPriceContainer = clubbiStyled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'end',
}))

export const StyledToggleButtonGroup = clubbiStyled(ToggleButtonGroup)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  position: 'relative',
}))

export const StyledToggleButton = clubbiStyled(ToggleButton)(({ theme }) => ({
  textTransform: 'none',
  width: '100%',
  padding: '8px 14px',
  fontSize: theme.typography.fontSize2XS,
  fontWeight: 400,
  borderRadius: '4px !important',
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'space-between',
  border: `1px solid ${theme.palette.brandGrey[20]} !important`,
  marginLeft: '1px !important',
  color: theme.palette.brandGrey[100],
  backgroundColor: theme.palette.brandWhite.main,
  '.days-to-delivery': {
    paddingTop: '4px',
    flexDirection: 'column',
    color: theme.palette.brandGrey[60],
    fontWeight: 400,
    lineHeight: 1.6,
  },
  '.free-shipping': {
    color: theme.palette.brandSuccess[70],
    fontWeight: 600,
  },

  '&.Mui-disabled': {
    border: `1px solid ${theme.palette.brandPurple[60]} !important`,
    backgroundColor: theme.palette.brandWhite.main,
    color: theme.palette.brandBlack.main,
    fontWeight: 600,
  },

  [theme.breakpoints.up('md')]: {
    fontSize: theme.typography.fontSizeXXS,
    '.days-to-delivery': {
      fontSize: theme.typography.fontSize2XS,
    },
  },
}))

export const StyledType = clubbiStyled('div')(() => ({
  textAlign: 'initial',
  flex: '1 !important',
}))

export const StyledParagraph = clubbiStyled('p')(({ theme }) => ({
  marginBottom: '4px',
}))

export const StyledAlert = clubbiStyled('p')(({ theme }) => ({
  color: theme.palette.brandAlert[50],
  marginBottom: '4px',
}))
